<div class="content" [innerHTML]="receiptXml() | html: {sanitize: false}"></div>
